import { useState, useEffect } from 'react'
import { Package } from '../config/api'
import { PackageService } from '../services/packageService'

export const useFeaturedPackages = () => {
  const [featuredPackages, setFeaturedPackages] = useState<Package[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const packageService = PackageService.getInstance()

  useEffect(() => {
    const fetchFeaturedPackages = async () => {
      try {
        setLoading(true)
        setError(null)

        // Fetch packages with a larger per_page to get more packages to filter from
        const response = await packageService.getPackages(1, { per_page: 50 })

        // Show only packages that are actually published, and then prefer featured ones.
        // Some APIs may return featured as non-boolean values, so normalize defensively.
        const isFeatured = (value: unknown) => value === true || value === 1 || value === '1' || value === 'true'
        const published = response.packages.filter((pkg) => pkg.published)
        const featured = published.filter((pkg) => isFeatured(pkg.featured))

        // If no featured packages found, take the first 3 packages as fallback
        if (featured.length === 0) {
          setFeaturedPackages(published.slice(0, 3))
        } else {
          setFeaturedPackages(featured)
        }
      } catch (err) {
        console.error('Error fetching featured packages:', err)
        setError(err instanceof Error ? err.message : 'Failed to fetch featured packages')
      } finally {
        setLoading(false)
      }
    }

    fetchFeaturedPackages()
  }, [packageService])

  return {
    featuredPackages,
    loading,
    error,
  }
}
